import Appointment from './appointment/model';
import OnePartA from './one-part-a/model';
import OnePartB from './one-part-b/model';
import Two from './two/model';
import ThreeToFour from './three-to-four/model';
import Five from './five/model';
import Six from './six/model';
import Seven from './seven/model';
import Eight from './eight/model';
import Nine from './nine/model';
import Ten from './ten/model';
import Signature from './signature/model';

const models = Object.freeze({
  Appointment,
  OnePartA,
  OnePartB,
  Two,
  ThreeToFour,
  Five,
  Six,
  Seven,
  Eight,
  Nine,
  Ten,
  Signature,
});

export default models;
